/** Static routes + resources/cases generated from src/content (app code: client and prerender). */
import { SEO_ROUTES, SITE_URL, findRouteIn, type SeoRoute } from "./routes";
import { contentRoutes } from "@/content/shared";
import { LIBRARY } from "@/content/library";

export const CONTENT_ROUTES: SeoRoute[] = contentRoutes(LIBRARY, SITE_URL);
export const ALL_ROUTES: SeoRoute[] = [...SEO_ROUTES, ...CONTENT_ROUTES];

export const findRoute = (basePath: string) => findRouteIn(ALL_ROUTES, basePath);
